import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import bgLogin from "../../assets/bgLogin.png";
import "./styles.css";
import { phone, cpfCnpj, unMask } from "../../services/mask";
import { validaCpfCnpj } from "../../services/validaCpfCnpj";
import { message } from "antd";
import ApiServicesLogin from "../../services/apiLogin";

export default function Cadastro() {
  const history = useHistory();
  
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    phoneNumber: "",
    senha: "",
    confirmarSenha: "",
    cpfCnpj: "",
  });

  const [errors, setErrors] = useState({});
  const [cpfCnpjValido, setCpfCnpjValido] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({
    score: 0,
    criteria: {
      length: false,
      letters: false,
      numbers: false,
      uppercase: false,
      special: false
    }
  });

  const validatePassword = (password) => {
    const criteria = {
      length: password.length >= 8,
      letters: /[a-zA-Z]/.test(password),
      numbers: /\d/.test(password),
      uppercase: /[A-Z]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };

    const score = Object.values(criteria).filter(Boolean).length;
    
    setPasswordStrength({
      score,
      criteria
    });

    return score >= 4; // Mínimo 4 critérios atendidos
  };

  const validateForm = () => {
    const newErrors = {};

    // Validar nome
    if (!formData.nome?.trim()) {
      newErrors.nome = "Nome é obrigatório";
    }

    // Validar email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email?.trim()) {
      newErrors.email = "Email é obrigatório";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Email inválido";
    }

    // Validar telefone
    if (!formData.phoneNumber?.trim()) {
      newErrors.phoneNumber = "Telefone é obrigatório";
    }

    // Validação do CPF/CNPJ (usando a mesma lógica do usuarioNovoEditar.js)
    if (!formData.cpfCnpj?.trim()) {
      newErrors.cpfCnpj = "CPF/CNPJ é obrigatório";
    } else if (formData.cpfCnpj && formData.cpfCnpj.length > 0) {
      const valorNumerico = formData.cpfCnpj.replace(/\D/g, "");
      if (
        valorNumerico.length !== 11 &&
        valorNumerico.length !== 14
      ) {
        newErrors.cpfCnpj = "CPF/CNPJ inválido";
      } else if (!validaCpfCnpj(valorNumerico)) {
        newErrors.cpfCnpj = "CPF/CNPJ inválido";
      }
    }

    // Validar senha
    if (!formData.senha) {
      newErrors.senha = "Senha é obrigatória";
    } else if (!validatePassword(formData.senha)) {
      newErrors.senha = "Senha não atende aos critérios mínimos";
    }

    // Validar confirmação de senha
    if (!formData.confirmarSenha) {
      newErrors.confirmarSenha = "Confirmação de senha é obrigatória";
    } else if (formData.senha !== formData.confirmarSenha) {
      newErrors.confirmarSenha = "As senhas não coincidem";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    // Aplicar máscaras
    if (name === "telefone") {
      formattedValue = phone(value);
      // Atualizar também o campo phoneNumber para validação
      setFormData({
        ...formData,
        [name]: formattedValue,
        phoneNumber: formattedValue,
      });
      return;
    } else if (name === "cpfCnpj") {
      formattedValue = cpfCnpj(value);
    }

    setFormData({
      ...formData,
      [name]: formattedValue,
    });

    // Validação em tempo real para CPF/CNPJ (usando a mesma lógica do usuarioNovoEditar.js)
    if (name === "cpfCnpj") {
      const valorNumerico = value.replace(/\D/g, "");
      const novosErros = { ...errors };

      delete novosErros.cpfCnpj;

      if (
        valorNumerico.length > 0 &&
        valorNumerico.length !== 11 &&
        valorNumerico.length !== 14
      ) {
        novosErros.cpfCnpj =
          "CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos";
        setCpfCnpjValido(false);
      } else if (valorNumerico.length > 0 && !validaCpfCnpj(valorNumerico)) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
        setCpfCnpjValido(false);
      } else if (valorNumerico.length === 11 || valorNumerico.length === 14) {
        setCpfCnpjValido(true);
      } else {
        setCpfCnpjValido(false);
      }

      setErrors(novosErros);
    } else {
      // Validar senha em tempo real
      if (name === "senha") {
        validatePassword(formattedValue);
      }

      // Limpar erro do campo quando o usuário começar a digitar
      if (errors[name]) {
        setErrors({
          ...errors,
          [name]: "",
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      message.error("Por favor, corrija os erros no formulário");
      return;
    }

    try {
      // Remover máscaras antes de enviar para a API
      const cpfCnpjLimpo = unMask(formData.cpfCnpj);
      const telefoneLimpo = unMask(formData.phoneNumber);
      
      // Gerar login a partir do email (antes do @)
      const login = formData.email.split('@')[0];

      const dataToSubmit = {
        login: login,
        email: formData.email,
        perfil: "Participante",
        isAdmin: false,
        nome: formData.nome,
        cpfCnpj: cpfCnpjLimpo,
        telefone: telefoneLimpo,
        senha: formData.senha,
        permissoes: [
          {
            id: "889E7779-C6AB-4409-B6AF-470E56A38DBF",
            nome: "Participante",
            status: true
          }
        ]
      };

      const response = await ApiServicesLogin.apiPost(
        "Usuario/cadastrar-usuario",
        dataToSubmit
      );

      message.success("Cadastro realizado com sucesso!");
      
      // Redirecionar para login após cadastro bem-sucedido
      history.push("/");
    } catch (error) {
      console.error("Erro no cadastro:", error);
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Erro ao realizar cadastro. Tente novamente.");
      }
    }
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength.score <= 1) return "#ff4d4f";
    if (passwordStrength.score <= 2) return "#faad14";
    if (passwordStrength.score <= 3) return "#1890ff";
    return "#52c41a";
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength.score <= 1) return "Muito fraca";
    if (passwordStrength.score <= 2) return "Fraca";
    if (passwordStrength.score <= 3) return "Média";
    return "Forte";
  };

  return (
    <div className="login-container">
      <div className="login-content cadastro">
        <h2>
          <b className="fontGellyBold">Cadastro</b>
        </h2>
        <hr
          style={{
            width: "40px",
            margin: "16px 0 0 0",
            border: "1.5px solid #979797",
          }}
        />
        <p style={{ fontSize: 15 }}>
          Preencha os dados abaixo para criar sua conta no Geely Brand Hub.
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
            <div className="form-group">
              <label htmlFor="nome" style={{ fontWeight: "bold" }}>
                Nome Completo
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                placeholder="Informe seu nome completo"
                value={formData.nome}
                onChange={handleInputChange}
                className={errors.nome ? "error" : ""}
              />
              {errors.nome && <span className="error-message">{errors.nome}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="cpfCnpj" style={{ fontWeight: "bold" }}>
                CPF/CNPJ
              </label>
              <input
                type="text"
                id="cpfCnpj"
                name="cpfCnpj"
                placeholder="000.000.000-00"
                value={formData.cpfCnpj}
                onChange={handleInputChange}
                className={errors.cpfCnpj ? "error" : cpfCnpjValido ? "valid" : ""}
              />
              {errors.cpfCnpj && <span className="error-message">{errors.cpfCnpj}</span>}
              {cpfCnpjValido && !errors.cpfCnpj && (
                <span className="valid-message">CPF/CNPJ válido</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="email" style={{ fontWeight: "bold" }}>
                E-mail
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Informe seu e-mail"
                autoComplete="email"
                value={formData.email}
                onChange={handleInputChange}
                className={errors.email ? "error" : ""}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="telefone" style={{ fontWeight: "bold" }}>
                Telefone
              </label>
              <input
                type="text"
                id="telefone"
                name="telefone"
                placeholder="(00) 00000-0000"
                value={formData.telefone}
                onChange={handleInputChange}
                className={errors.phoneNumber ? "error" : ""}
              />
              {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="senha" style={{ fontWeight: "bold" }}>
                Senha
              </label>
              <div className="input-password">
                <input
                  type="password"
                  id="senha"
                  name="senha"
                  placeholder="Informe sua senha"
                  autoComplete="new-password"
                  value={formData.senha}
                  onChange={handleInputChange}
                  className={errors.senha ? "error" : ""}
                />
                <span className="icon-eye">{/* Ícone de olho aqui */}</span>
              </div>
              {errors.senha && <span className="error-message">{errors.senha}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="confirmarSenha" style={{ fontWeight: "bold" }}>
                Confirmar Senha
              </label>
              <div className="input-password">
                <input
                  type="password"
                  id="confirmarSenha"
                  name="confirmarSenha"
                  placeholder="Confirme sua senha"
                  autoComplete="new-password"
                  value={formData.confirmarSenha}
                  onChange={handleInputChange}
                  className={errors.confirmarSenha ? "error" : ""}
                />
                <span className="icon-eye">{/* Ícone de olho aqui */}</span>
              </div>
              {errors.confirmarSenha && <span className="error-message">{errors.confirmarSenha}</span>}
            </div>
          </div>

          {/* Validação de senha */}
          {formData.senha && (
            <div className="password-validation mb-3">
              <div className="password-strength">
                <div className="strength-bar">
                  <div 
                    className="strength-fill"
                    style={{ 
                      width: `${(passwordStrength.score / 5) * 100}%`,
                      backgroundColor: getPasswordStrengthColor()
                    }}
                  ></div>
                </div>
                <span className="strength-text" style={{ color: getPasswordStrengthColor() }}>
                  {getPasswordStrengthText()}
                </span>
              </div>
              
              <div className="password-criteria">
                <div className={`criteria-item ${passwordStrength.criteria.length ? 'met' : ''}`}>
                  ✓ Mínimo 8 caracteres
                </div>
                <div className={`criteria-item ${passwordStrength.criteria.letters ? 'met' : ''}`}>
                  ✓ Letras (a-z)
                </div>
                <div className={`criteria-item ${passwordStrength.criteria.numbers ? 'met' : ''}`}>
                  ✓ Números (0-9)
                </div>
                <div className={`criteria-item ${passwordStrength.criteria.uppercase ? 'met' : ''}`}>
                  ✓ Letra maiúscula (A-Z)
                </div>
                <div className={`criteria-item ${passwordStrength.criteria.special ? 'met' : ''}`}>
                  ✓ Caractere especial (!@#$%^&*)
                </div>
              </div>
            </div>
          )}

          <button type="submit" className="btn-login">
            Cadastrar
          </button>
        </form>

        <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "12px" }}>
          <Link
            to="/"
            style={{ color: "#979797", textDecoration: "none" }}
          >
            Já tenho uma conta - Fazer login
          </Link>
        </div>
      </div>
    </div>
  );
} 